import React, { useState, useEffect } from "react";
import MobilePageLayout from "../components/MobilePageLayout";
import HomeButton from "../components/HomeButton";
import HttpService from "../sdk/HttpAxios";

const ActiveOrdersPage = ({ onNext }) => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [popup, setPopup] = useState("");

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const http = new HttpService();
      const response = await http.get("/store/orders/mobile");
      // console.log("Orders fetched:", response);
      setOrders(response);
      setLoading(false);
    } catch (error) {
      // console.error("Failed to fetch orders:", error);
      showPopup("Failed to load orders. Please try again.");
      setLoading(false);
    }
  };

  const showPopup = (msg) => {
    setPopup(msg);
    setTimeout(() => setPopup(""), 8000); // show for 8 seconds
  };

  const handleUnlock = () => {
    if (selectedOrder) {
      // console.log("Unlocking order:", selectedOrder);
      onNext({ selectedOrder });
    }
  };

  const handleSelectOrder = (order) => {
    setSelectedOrder(order);
  };

  return (
    <MobilePageLayout
      ctaLabel="Unlock"
      onCtaClick={handleUnlock}
      ctaDisabled={!selectedOrder}
    >
      <HomeButton />

      <h2 className="page-title">Orders</h2>
      <ul>
        <li>Make sure the Bluetooth on phone is turned on</li>
        <li>Select the order and press Unlock</li>
        <li>Pair with the locker when prompted</li>
        <li>Close the door firmly after retrieving items</li>
      </ul>

      {loading ? (
        <p className="status">Loading orders...</p>
      ) : orders.length === 0 ? (
        <p className="status">No active orders found</p>
      ) : (
        <div className="orders-container">
          {orders.map((order) => (
            <div
              key={order.id}
              className={`order-card ${selectedOrder?.id === order.id ? "selected" : ""}`}
              onClick={() => handleSelectOrder(order)}
            >
              <div className="order-card-content">
                <div className="order-card-info">
                  <div className="order-header">
                    <h3 className="order-title">
                      {order.meta?.terName || "Terminal"}
                    </h3>
                    <span
                      className={`order-status status-${order.orderStatus}`}
                    >
                      {order.orderStatus}
                    </span>
                  </div>
                  <div className="order-details">
                    <div className="order-row">
                      <span className="order-label">Order#:</span>
                      <span className="order-value">{order.orderNumber}</span>
                    </div>
                    <div className="order-row">
                      <span className="order-label">Box:</span>
                      <span className="order-value">{order.boxName}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {popup && <div className="popup">{popup}</div>}
    </MobilePageLayout>
  );
};

export default ActiveOrdersPage;
